<app-header (notifyMobileOpen)="getMobileOpenNotification($event)"></app-header>
<div class="mainContainer">

    <app-menu selectedItem="benutzerverwaltung" class="menu" [class.open]="mobileMenuOpen"></app-menu>

    <div class="content" [class.closed]="mobileMenuOpen">

        @if (!task) {
            <div>
                <h1>Benutzerverwaltung</h1>
                <h2>
                    Übersicht aller Benutzer
                    <div class="options">
                        <button class="btn-white-orange" (click)="benutzerAnlegen()">
                            <span class="btn-ico-neu"></span>
                            <span class="btn-text">Neuen Nutzer anlegen</span>
                        </button>
                    </div>
                </h2>
                @if (visibleUser) {
                    <div>
                        <pagination [numItems]="visibleUser.length"
                                    [current]="currentOffset"
                                    (goToPageEvent)="pagerAction($event)"></pagination>
                        <elem-table [tableData]="visibleUser"
                                    [tableMeta]="userMetaData"
                                    [actionFn]="deleteAction"
                                    [targetParam]="'uid'"
                                    [searchAction]="searchMe"
                                    [detailsClass]="'deleteEntry'"
                                    [detailsTitle]="'Löschen'"
                                    [currentOffset]="currentOffset"
                                    [lineHasChild]="false"
                                    (goToPageEvent)="pagerAction($event)">
                        </elem-table>
                        <pagination [numItems]="visibleUser.length"
                                    [current]="currentOffset"
                                    (goToPageEvent)="pagerAction($event)"></pagination>
                    </div>
                }
            </div>
        } @else if (task === 'benutzerAnlegen') {
            <benutzer-anlegen></benutzer-anlegen>
        }

    </div>
</div>
